// Дані власника адмінки. Раніше тут лишався бренд шаблону («Structure Lab»),
// і саме він вітав адміністратора на головному екрані.
export const siteData = {
    name: 'UBC',
    description: 'Панель керування сайтом Ukrainian British College',
    img: '/img/logo.svg',
};
